import { cn } from '@/lib/utils';
import { MOODS } from '@/features/workMode/types';

interface WorkMoodPickerProps {
  value: number | null;
  onChange: (mood: 1 | 2 | 3 | 4 | 5) => void;
  size?: 'lg' | 'md';
  disabled?: boolean;
  className?: string;
}

/** Five big faces. Used on the tablet check-in and in the app's own check-in card. */
export function WorkMoodPicker({ value, onChange, size = 'lg', disabled, className }: WorkMoodPickerProps) {
  return (
    <div role="radiogroup" aria-label="How do you feel today?" className={cn('flex w-full justify-between gap-2', className)}>
      {MOODS.map((m) => {
        const active = value === m.value;
        return (
          <button
            key={m.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onChange(m.value)}
            className={cn(
              'flex flex-1 flex-col items-center justify-center gap-1 rounded-2xl border transition-all select-none',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              'disabled:opacity-50',
              size === 'lg' ? 'min-h-[104px] py-3' : 'min-h-[64px] py-2',
              active
                ? 'border-info bg-info-soft/30 shadow-[0_0_0_3px_hsl(var(--info)/0.15)]'
                : 'border-border bg-card hover:bg-secondary',
            )}
          >
            <span className={cn(size === 'lg' ? 'text-4xl' : 'text-2xl', !active && 'grayscale-[35%] opacity-80')} aria-hidden>
              {m.emoji}
            </span>
            <span className={cn('font-medium', size === 'lg' ? 'text-sm' : 'text-xs', active ? 'text-info' : 'text-muted-foreground')}>
              {m.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
